import Vue from "vue"
// .map(requireContext)
const requireAll = requireContext => requireContext.keys()
// console.log(requireAll)
const req = require.context("./icons", false, /\.svg$/)
// console.log(req)
const iconMap = requireAll(req)
// console.log("iconMap",iconMap);
// e.slice(3) 老写法
Vue.prototype.$IconSvg = iconMap.map(e => e.split("/")[1].split(".")[0])
// Vue.prototype.$IconSvg = iconMap.map(e =>console.log(e.default))
